// Converts seconds to a string in minutes (e.g., 90 -> "1.5 min")
export function secondsToMinutes(seconds?: number): string {
  if (typeof seconds !== "number" || isNaN(seconds)) return "-";
  const minutes = seconds / 60;
  // Show up to 1 decimal if not a whole number
  return minutes % 1 === 0 ? `${minutes} min` : `${minutes.toFixed(1)} min`;
}
